// PDFHeaderControls.js
import AntRadioGroup from "../../../components/Ant/AntRadioGroup/AntRadioGroup";
import AntSpin from "../../../components/Ant/AntSpin/AntSpin";
import Button from "../../../components/Button";
import styled from "styled-components";
import backIcon from "../../../assets/back_icon.svg";
import styles from "./PDFReportViewer.module.css";

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  width: 304px;
  min-width: 304px;
`;

const BackButton = styled.img`
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 20px;
`;

const ReportTitle = styled.p`
  margin: 0;
  font-family: "Poppins";
  font-size: 24px;
  color: #454b60;
  min-width: 160px;
`;

const PDFHeaderControls = ({
  t,
  title,
  onBack,
  allowCustomWidths,
  columnWidthTypeRadioValue,
  setColumnWidthTypeRadioValue,
  fontSizeRadioValue,
  setFontSizeRadioValue,
  onDownload,
  isLoading,
  onIsLoading,
}) => {
  const columnWidthRadioValues = allowCustomWidths ? [1, 2, 3] : [1, 2];
  const columnWidthLabels = allowCustomWidths
    ? [t("variableColumnLabel"), t("equalColumnLabel"), t("customColumnLabel")]
    : [t("variableColumnLabel"), t("equalColumnLabel")];

  return (
    <>
      <TitleGroup>
        <BackButton src={backIcon} onClick={onBack} />
        <ReportTitle>{t("title")}</ReportTitle>

        <AntRadioGroup
          values={columnWidthRadioValues}
          labels={columnWidthLabels}
          radioGroupClass="ant-radioGroup-000"
          onChange={(e) => setColumnWidthTypeRadioValue(e.target.value)}
          value={columnWidthTypeRadioValue}
        />

        <div className={styles.PDFReportViewer__fontSizeRadioGroupContainer}>
          <AntRadioGroup
            values={[1, 2]}
            labels={[t("largeFontLabel"), t("smallFontLabel")]}
            radioGroupClass="ant-radioGroup-000"
            onChange={(e) => {
              const value = e.target.value;
              setFontSizeRadioValue(value);
            }}
            value={fontSizeRadioValue}
          />
        </div>
      </TitleGroup>

      <div className={styles.PDFReportViewer__controlsButtonGroup}>
        {isLoading && (
          <div className={styles.PDFReportViewer__loadingSpinner}>
            <AntSpin
              message=""
              containerStyle="container-000"
              spinnerStyle="ant-spin-000"
              messageStyle="message-000"
              spinSize="small"
            />
          </div>
        )}
        <Button
          onClick={() => {
            onIsLoading(true);
            onDownload();
          }}
          labelName="Download PDF"
          isPrimary
          isDiabled={isLoading}
        >
          {/* {isLoading ? "Preparing..." : "Download PDF"} */}
        </Button>
      </div>
    </>
  );
};

export default PDFHeaderControls;
